import React from 'react';
import _ from 'lodash';

import { Header, Footer } from 'react-scale/components';
import Hero from 'react-scale/components/pages/interviews-old/index/Hero';
import VideoList from 'react-scale/components/pages/interviews-old/index/VideoList';

import { content } from 'react-scale/components/pages/interviews-old/Content';
import { themeDark } from 'react-scale/components/elements/header/header-themes';

const Interviews = () => (
  <div className="bg-black">
    <Header
      title="AI Futures by Scale - Interview Series with leading researchers"
      description="AI Futures is an interview series with leading researchers and practitioners in the AI and Machine Learning space about the future of the industry."
      canonical="https://scale.com/interviews"
      ogImg="https://scale.ai/static/img/website/interviews/social/fb.png"
      twImg="https://scale.ai/static/img/website/interviews/social/tw.png"
      theme={themeDark}
      favicon="interviews"
    />
    <Hero />
    <VideoList items={_.values(content)} />
    <Footer
      textColor="text-neutral-400"
      textHoverColor="text-white"
      borderColor="border-neutral-900"
      border
    />
  </div>
);

export default Interviews;
